import EnchancedIcon from "../../../assets/icons/cii-value-org/enhanced.png";
import InsightIcon from "../../../assets/icons/cii-value-org/insight.png";
import DiveIcon from "../../../assets/icons/cii-value-org/dive.png";
import StreamlinedIcom from "../../../assets/icons/cii-value-org/streamlined.png";

export const valueOrgContent = [
  {
    icon: EnchancedIcon,
    title: "Enhanced Decision Making",
    description:
      'Select the income target option that best suits your analysis - either "Better Income Target" or "Living Income Driver."',
  },
  {
    icon: InsightIcon,
    title: "Greater Insights for Strategic Planning",
    description:
      "Then, follow the prompts to input the relevant data for each income driver, including breakdown levels where applicable.",
  },
  {
    icon: DiveIcon,
    title: "Dive deeper into understanding the income gap",
    description:
      "You will be able to delve deeper into the income gap and understand what drivers you can leverage to close the income gap for different farmer segments",
  },
  {
    icon: StreamlinedIcom,
    title: "Streamlined Reporting",
    description:
      "Data requests can be integrated into ISCO reporting, reducing redundancy and administrative burden.",
  },
];
